import '@angular/localize/init';
import 'core-js/es';
import 'core-js/proposals/reflect-metadata';
import 'zone.js';

if (process.env.ENV === 'production') {
    // Production
} else {
    // Development and test
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/plugins/long-stack-trace-zone');
}
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype['msMatchesSelector'];
}